import { render, staticRenderFns } from "./ChequeWithdrawal.vue?vue&type=template&id=0d228ca2"
import script from "./ChequeWithdrawal.vue?vue&type=script&lang=js"
export * from "./ChequeWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports